// src/features/profile/api/profile/read.js
import axiosInstance from '@/lib/axios';

// ✅ Helper to get auth headers
function getAuthHeaders() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  if (!token || !tokenType) throw new Error('You are not authorized.');
  return { Authorization: `${tokenType} ${token}` };
}



export async function readUserApi() {
  try {
    const response = await axiosInstance.get('/users/me', {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication expired.');
    }
    throw error;
  }
}



export async function updateUserApi(formData) {


  try {

    const response = await axiosInstance.patch('/users/me', formData, {
      headers: getAuthHeaders(), // Let axios handle FormData Content-Type
    });

    console.log(response.data)
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to update profile: ' + message);
  }
}




export async function updatePasswordApi({ oldPassword, newPassword, confirmPassword }) {
  if (newPassword !== confirmPassword) throw new Error('New passwords do not match!');

  try {
    const response = await axiosInstance.patch(
      '/users/me/password',
      {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_new_password: confirmPassword,
      },
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Password change failed: ' + message);
  }
}

export async function deleteUserApi() {
  try {
    const response = await axiosInstance.delete('/users/me', {
      headers: getAuthHeaders(),
    });
    return response.status === 200; // returns true if successful
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to delete account: ' + message);
  }
}













// ✅ Get user's website rating
export async function getWebsiteRate() {
  try {
    const response = await axiosInstance.get('/users/website/me', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to fetch website rate: ' + message);
  }
}

// ✅ Create website rating
export async function createWebsiteRate({ rate, comment }) {
  try {
    const payload = comment ? { rate, comment } : { rate };
    const response = await axiosInstance.post('/users/website', payload, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to create website rate: ' + message);
  }
}

// ✅ Update website rating
export async function patchWebsiteRate({ rate, comment }) {
  try {
    const payload = comment ? { rate, comment } : { rate };
    const response = await axiosInstance.patch('/users/website', payload, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to update website rate: ' + message);
  }
}

// ✅ Fetch all user ratings
export async function fetchRatings() {
  try {
    const response = await axiosInstance.get('/users/me/ratings', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to fetch ratings: ' + message);
  }
}








// ✅ Fetch user scoreboard
export async function fetchScoreBoard() {
  try {
    const response = await axiosInstance.get('/users/me/scoreboard', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to fetch scoreboard: ' + message);
  }
}

// ✅ Fetch user match history
export async function fetchMatchHistory() {
  try {
    const response = await axiosInstance.get('/users/me/matchhistory', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to fetch match history: ' + message);
  }
}








export async function submitReportMatch(match_id, content) {



  const response = await axiosInstance.post(
    `/report/match`,
    { match_id, content },

  );

  return {
    success: true,
    data: response.data,
    message: "Report submitted successfully."
  }

}
